module.exports = __webpack_public_path__ + "static/media/ceoReady2.e23fedc9.png";